import { Card, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';

import { formatName, formatPhone } from '@utils/format';

import type { PatientCareTeamModel } from 'generated/types';

import DirectivesEntry from '../Directives/DirectivesEntry';
import { SectionH2 } from '../HealthSummary.style';

const messages = defineMessages({
  title: {
    id: 'careTeam.title',
    defaultMessage: 'Healthcare Contacts',
  },
  noData: {
    id: 'careTeam.noContacts',
    defaultMessage: 'No Contacts',
  },
});

interface CareTeamProps {
  care_team?: PatientCareTeamModel | null;
  clickable?: boolean;
  loading?: boolean;
}

function CareTeam({
  //   clickable = false,
  loading = false,
  care_team,
}: CareTeamProps) {
  const { formatMessage } = useIntl();
  const participants = care_team?.participants ?? [];

  return (
    <Card sx={{ p: 2.5 }}>
      <ContentLoader loading={loading}>
        <>
          <SectionH2>{formatMessage(messages.title).toUpperCase()}</SectionH2>

          {participants.length > 0 ? (
            participants.map((p) => (
              <DirectivesEntry
                clickable={false}
                data={[
                  `${formatName(p.prefix, p.first_name, p.last_name)}`,
                  `${p.phone ? formatPhone(p.phone) : ''}`,
                ]}
                key={`care-team-participant-${p.id}`}
                //    route={ROUTES.CONTACTS}
                route=""
                title={p.role_name}
              />
            ))
          ) : (
            <Typography variant="body2" mt={1} ml={1}>
              {formatMessage(messages.noData)}
            </Typography>
          )}
        </>
      </ContentLoader>
    </Card>
  );
}

export default CareTeam;
